import React from "react";

const ReviewAboutCardSection4 = (props) => {
  return (
    <div className="w-full slide lg:mt-32">
      <div className="w-screen ">
        <div className=" mt-24 w-[70%]">
          <div className="flex flex-col items-center">
            <img className="mx-44 w-44 " src={props.image} alt="" />
            <img className="mx-auto mt-5 w-16" src={props.image1} alt="" />
          </div>
          <p className="mt-5 text-xl text-center lg:font-semibold lg:text-xl">
            {props.para}
          </p>
          <h2 className="mt-16 text-2xl font-medium text-center">{props.title}</h2>
          <h1 className="mt-2 text-xl text-center">{props.title1}</h1>
        </div>
      </div>
    </div>
  );
};

export default ReviewAboutCardSection4;
